var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckBoxSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(-859 -723)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_737",
    "data-name": "Rectangle 737",
    width: 19,
    height: 19,
    rx: 3,
    transform: "translate(859 723)",
    fill: "#fabc2a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr",
    transform: "translate(858.52 726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkbox-2",
    d: "M5.481,6.272,6.317,5.5a16.112,16.112,0,0,1,2.7,1.617A23.355,23.355,0,0,1,14.988,2l.272.626c-2.094,1.827-3.628,3.863-5.836,7.823A41.964,41.964,0,0,0,5.481,6.272Z",
    fill: "#22274a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxSquare);
export default __webpack_public_path__ + "static/media/checkBoxSquare.0be1e79d.svg";
export { ForwardRef as ReactComponent };